import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js/instance/keys";
import moment from "moment";
import Handlebars from "handlebars";
import { MONTHS_NAMES } from "../constants";
export const select = function (value = "", options) {
  const element = $("<select />").html(options.fn(this));
  _findInstanceProperty(element).call(element, `[value='${value}']`).attr({
    selected: "selected"
  });
  if (value) _findInstanceProperty(element).call(element, "[value='']").removeAttr("selected");
  return element.html();
};
export const selectById = function (id, options) {
  const element = $("<select />").html(options.fn(this));
  _findInstanceProperty(element).call(element, `[data-id='${id}']`).attr({
    selected: "selected"
  });
  _findInstanceProperty(element).call(element, "[data-id='']").removeAttr("selected");
  return element.html();
};
export const fillMonths = function (selectedMonth) {
  var _context;
  return new Handlebars.SafeString(_mapInstanceProperty(_context = MONTHS_NAMES()).call(_context, (month, index) => `<option value="${index + 1}" ${selectedMonth == index + 1 ? "selected" : ""}>${month}</option>`).join(" "));
};
export const fillDays = function (selectedDay, selectedMonth, selectedYear) {
  var _context2;
  const monthLastDay = moment(`${selectedYear || moment().year()}-${selectedMonth || 1}`, "YYYY-M").daysInMonth();
  return new Handlebars.SafeString(_Array$from(_keysInstanceProperty(_context2 = Array(monthLastDay)).call(_context2), val => `<option value="${val + 1}" ${selectedDay == val + 1 ? "selected" : ""}>${val + 1}</option>`).join(" "));
};
export const fillYears = function (selectedYear) {
  const currentYear = moment().year();
  let yearOptions = "";
  for (let i = currentYear - 18; i > currentYear - 100; i--) {
    yearOptions += `<option value="${i}" ${selectedYear == i ? "selected" : ""}>${i}</option>`;
  }
  return new Handlebars.SafeString(yearOptions);
};
export const squareOption = function (value, options) {
  const element = $(options.fn(this));
  const found = _findInstanceProperty(element).call(element, `input[value='${value}']`);
  found.attr("checked", true);
  found.next().addClass("checked");
  return element[0].outerHTML;
};
export const radioForm = function (value, options) {
  const element = $(options.fn(this));
  const found = _findInstanceProperty(element).call(element, `input[value='${value}']`);
  found.attr("checked", true);
  return element[0].outerHTML;
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("select", select);
  _Handlebars.registerHelper("selectById", selectById);
  _Handlebars.registerHelper("fillMonths", fillMonths);
  _Handlebars.registerHelper("fillDays", fillDays);
  _Handlebars.registerHelper("fillYears", fillYears);
  _Handlebars.registerHelper("squareOption", squareOption);
  _Handlebars.registerHelper("radioForm", radioForm);
};